"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _CatalogueProductListMultipleFilterMobile = _interopRequireDefault(require("./CatalogueProductListMultipleFilterMobile"));

var _CatalogueProductListMultipleFilterDesktop = _interopRequireDefault(require("./CatalogueProductListMultipleFilterDesktop"));

function CatalogueProductListMultipleFilter(_ref) {
  var buildFilter = _ref.buildFilter,
      currency = _ref.currency,
      filter = _ref.filter,
      filterFields = _ref.filterFields,
      filterHash = _ref.filterHash,
      handleChangeOrder = _ref.handleChangeOrder,
      onChange = _ref.onChange,
      onChangeRowsPerPage = _ref.onChangeRowsPerPage,
      onChangeStockOnly = _ref.onChangeStockOnly,
      order = _ref.order,
      parentFilter = _ref.parentFilter,
      resetFilter = _ref.resetFilter,
      rowsPerPage = _ref.rowsPerPage,
      stockOnly = _ref.stockOnly,
      total = _ref.total;
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  var Component = mobile ? _CatalogueProductListMultipleFilterMobile.default : _CatalogueProductListMultipleFilterDesktop.default;
  return /*#__PURE__*/_react.default.createElement(Component, {
    buildFilter: buildFilter,
    currency: currency,
    filter: filter,
    filterHash: filterHash,
    onChange: onChange,
    resetFilter: resetFilter,
    parentFilter: parentFilter,
    total: total,
    filterFields: filterFields,
    handleChangeOrder: handleChangeOrder,
    onChangeRowsPerPage: onChangeRowsPerPage,
    onChangeStockOnly: onChangeStockOnly,
    stockOnly: stockOnly,
    rowsPerPage: rowsPerPage,
    order: order
  });
}

process.env.NODE_ENV !== "production" ? CatalogueProductListMultipleFilter.propTypes = {
  buildFilter: _propTypes.default.func,
  currency: _propTypes.default.string,
  filter: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.shape(_propTypes.default.arrayOf())]),
  filterFields: _propTypes.default.arrayOf(_propTypes.default.string),
  filterHash: _propTypes.default.string,
  handleChangeOrder: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onChangeRowsPerPage: _propTypes.default.func,
  onChangeStockOnly: _propTypes.default.func,
  order: _propTypes.default.string,
  parentFilter: _propTypes.default.arrayOf(_propTypes.default.shape()),
  resetFilter: _propTypes.default.func,
  rowsPerPage: _propTypes.default.number,
  stockOnly: _propTypes.default.bool,
  total: _propTypes.default.number
} : void 0;
CatalogueProductListMultipleFilter.defaultProps = {
  buildFilter: undefined,
  currency: undefined,
  filter: undefined,
  filterFields: undefined,
  filterHash: undefined,
  handleChangeOrder: undefined,
  onChange: undefined,
  onChangeRowsPerPage: undefined,
  onChangeStockOnly: undefined,
  order: undefined,
  parentFilter: undefined,
  resetFilter: undefined,
  rowsPerPage: undefined,
  stockOnly: undefined,
  total: undefined
};
var _default = CatalogueProductListMultipleFilter;
exports.default = _default;